<div class="split-wrapper">
  <div class="split-wrapper__header">
    <ebw-monorepo-sidebar-header [isSvg]="false" [icon]="conf.icon" [title]="conf.title"
      [vertical]="layoutConf.collapsed">
      <div *ngIf="conf.subtitle">
        {{ conf.subtitle }}
      </div>

      <ng-container tool>

        <ng-container *ngIf="!conf.hideExpandActions">
          <button mat-icon-button matTooltip="{{ layoutConf.halfScreen ? 'Espandi' : 'Riduci' }}"
            (click)="showFullOrHalf()">
            <ng-container *ngIf="layoutConf.halfScreen">
              <svg width="30" height="30" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_216_300" fill="white">
                  <rect x="24" y="25" width="150" height="150" rx="6" />
                </mask>
                <rect x="24" y="25" width="150" height="150" rx="6" stroke="#252440" stroke-width="16"
                  mask="url(#path-1-inside-1_216_300)" />
                <rect x="46" y="47" width="105" height="106" rx="6" fill="#302F55" />
              </svg>
            </ng-container>

            <ng-container *ngIf="!layoutConf.halfScreen">
              <svg width="30" height="30" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_216_291" fill="white">
                  <rect x="24" y="25" width="150" height="150" rx="7" />
                </mask>
                <rect x="24" y="25" width="150" height="150" rx="7" stroke="#252440" stroke-width="16"
                  mask="url(#path-1-inside-1_216_291)" />
                <rect x="47" y="47" width="49" height="105" rx="6" fill="#302F55" />
                <rect x="102" y="47" width="49" height="105" rx="6" fill="#302F55" />
              </svg>

            </ng-container>

          </button>


          <button mat-icon-button class="actions-btn__hide"
            matTooltip="{{ layoutConf.collapsed ? 'Mostra' : 'Nascondi' }}" (click)="collapseOrExpand()">
            <ng-container *ngIf="layoutConf.collapsed">
              <svg width="30" height="30" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_216_291" fill="white">
                  <rect x="24" y="25" width="150" height="150" rx="7" />
                </mask>
                <rect x="24" y="25" width="150" height="150" rx="7" stroke="#252440" stroke-width="16"
                  mask="url(#path-1-inside-1_216_291)" />
                <rect x="47" y="47" width="49" height="105" rx="6" fill="#302F55" />
                <rect x="102" y="47" width="49" height="105" rx="6" fill="#302F55" />
              </svg>
            </ng-container>
            <ng-container *ngIf="!layoutConf.collapsed">
              <svg width="30" height="30" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_216_296" fill="white">
                <rect x="24" y="25" width="150" height="150" rx="6"/>
                </mask>
                <rect x="24" y="25" width="150" height="150" rx="6" stroke="#252440" stroke-width="16" mask="url(#path-1-inside-1_216_296)"/>
                <rect x="46" y="45" width="26" height="107" rx="6" fill="#302F55"/>
                <rect x="85.5" y="47.5" width="65" height="102" rx="3.5" stroke="#302F55" stroke-width="5"/>
                </svg>


            </ng-container>

          </button>
        </ng-container>


        <button mat-icon-button matTooltip="Chiudi" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>

      </ng-container>
    </ebw-monorepo-sidebar-header>
  </div>

  <div class="split-wrapper__body" id="test_portal" [hidden]="layoutConf.collapsed"></div>
</div>